import { validatorPayDay, validatorPresentDays } from './rules'

export default function config() {
  // 支付计划底部统计默认展示列表
  const m_bottomTotalDefaultList = [
    {
      code: 1,
      number: 0,
    },
    {
      code: 2,
      number: 0,
    },
    {
      code: 3,
      number: 0,
    },
    {
      code: 4,
      number: 0,
    },
  ]
  // 周付 缴款日下拉列表
  const m_weekList = [
    {
      code: 1,
      name: '每周一',
    },
    {
      code: 2,
      name: '每周二',
    },
    {
      code: 3,
      name: '每周三',
    },
    {
      code: 4,
      name: '每周四',
    },
    {
      code: 5,
      name: '每周五',
    },
    {
      code: 6,
      name: '每周六',
    },
    {
      code: 7,
      name: '每周日',
    },
  ]
  // 支付计划校验
  const m_rules = {
    presentDays: [
      { validator: validatorPresentDays.bind(this), trigger: 'change' },
    ],
    payDay: [
      { validator: validatorPayDay, trigger: 'change' },
    ],
  }
  // 阶梯配置 默认两个阶梯
  const ladderSchemeConfig = {
    isOpen: 0,
    unit: 1,
    clickNumber: 0, // 点击匹配租金次数
    ladderSchemeList: [
      {
        startMonth: 1, // 开始时间为1
        endMonth: '',
        amount: '',
      },
      {
        startMonth: '',
        endMonth: '',
        amount: '',
      },
    ],
  }
  //  关联订单信息
  const m_relationOrderInfo = [
    {
      el: 'text',
      itemConfig: {
        label: '关联原因',
        prop: 'relatedTypeName',
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '关联合同说明',
        prop: 'relatedExplain',
      },
      elConfig: {
        clearable: true,
        type: 'textarea',
        maxlength: 500,
      },
    },
  ]
  const m_relationOrderInfoModel = {}
  return {
    m_relationOrderInfo,
    m_relationOrderInfoModel,
    ladderSchemeConfig,
    m_rules,
    m_bottomTotalDefaultList,
    m_weekList,
  }
}
